module.exports = __webpack_public_path__ + "static/media/linkIcon.7a155fb6.svg";